module.exports = __webpack_public_path__ + "static/media/20200907_H_Solution 1.14694ca2.svg";